import Vue from 'vue'
import Router from 'vue-router'

const approvalView = r => require(['@/views/approvalView.vue'], r) // 审批根组建
const processView = r => require(['@/views/processView.vue'], r) // 发起流程根组件
const personCenter = r => require(['@/views/personCenter.vue'], r) // 个人中心
const hasHandle = r => require(['@/views/hasHandle.vue'], r) // 审批根组建

// const iframeForm = r => require(['@/views/approvalView/iframeForm'], r) // 业务系统内嵌页面
const processInfo = r => require(['@/views/approvalView/processInfo'], r) // 审批信息
const processHistroy = r => require(['@/views/approvalView/processHistroy'], r) // 审批记录

const processInfoHandle = r => require(['@/views/hasHandle/processInfo'], r) // 已办_审批
const histroyHandle = r => require(['@/views/hasHandle/processHistroy'], r) // 已办_审批记录
// const iframeFormHandle = r => require(['@/views/hasHandle/iframeForm'], r) // 已办_业务系统内嵌页面
const processInfo2 = r => require(['@/views/processView/processInfo'], r) // 发起流程_审批
const onlyReadProcessInfo = r => require(['@/views/onlyReadProcessInfo'], r)
// const processIframeForm = r => require(['@/views/processView/iframeForm'], r) // 业务系统内嵌页面
const roleCompletion = r => require(['@/views/processView/roleCompletion'], r) // 角色补全
const roleCompletionMobile = r => require(['@/components/mobile/roleCompletionMobile'], r) // 角色补全
const roleCompletionReport = r => require(['@/views/processView/roleCompletionReport'], r) // 角色补全报表

const myTodoBelongToMe = r => require(['@/views/personCenter/myTodo'], r) // 我的代办
const myAlreadydone = r => require(['@/views/personCenter/myAlreadydone'], r) // 我的已办
const myInitiation = r => require(['@/views/personCenter/myInitiation'], r) // 我的发起

const myProcessMap = r => require(['@/views/personCenter/myProcessMap'], r) // 流程地图
const myBpmPortal = r => require(['@/views/personCenter/myBpmPortal'], r) // 流程门户
const myInterApprover = r => require(['@/views/personCenter/myInterApprover'], r) // 流程门户
const myMaintain = r => require(['@/views/personCenter/myMaintain'], r)
//测试demo
const Test = r => require(['@/views/test'], r) // 测试页面

const form = r => require(['@/views/demo/formnew'], r) // test2
const beifen = r => require(['@/views/demo/beifen'], r) // test2
const secondClick = r => require(['@/views/demo/secondClick'], r) // test2
const formread = r => require(['@/views/demo/formold'], r) // test2
const formiframe = r => require(['@/views/demo/formiframe'], r) // test2
const primaryBtnSuccess = r => require(['@/views/demo/primaryBtnSuccess'], r) // test2
const demotest = r => require(['@/views/demo/demotest'], r) // 六合一demo
const noLoading = r => require(['@/views/demo/noLoading'], r) // 六合一demo

const forward = r => require(['@/components/mobile/forward/index'], r)
const searchForward = r => require(['@/components/mobile/forward/searchForward'], r)

const check = r => require(['@/components/mobile/check'], r)
const search = r => require(['@/components/mobile/search'], r)

const examine = r => require(['@/components/mobile/common/examine'], r)
const selectrole = r => require(['@/components/mobile/selectrole'], r)
const selectPerson = r => require(['@/components/mobile/selectPerson'], r)
const processTest = r => require(['@/views/processTest'], r)
const ownerConfigTabel = r => require(['@/views/ownerConfigTabel'], r)
const countersign = r => require(['@/views/countersign'], r)

const templateExport = r => require(['@/views/templateExport'], r) // 流程配置模板导出
const changePeople = r => require(['@/views/changePeople'], r) // 流程配置模板导出

const toDoException = r => require(['@/views/toDoException/index'], r) // 异常待办
const toPushMq = r => require(['@/views/toPushMq/index'], r) // 推送mq
const timeoutReminder = r => require(['@/views/timeoutReminder/index'], r) // 超时和系统规则配置

const logPageLook  = r => require(['@/views/logPage/logPageLook'], r) // 日志
const logPageAdd  = r => require(['@/views/logPage/logPageAdd'], r) // 日志
const logPageView = r => require(['@/views/logPage/logPageView'], r) // 日志
const logPagedetial = r => require(['@/views/logPage/logPagedetial'], r) // 日志

const RegisterLook  = r => require(['@/views/Register/RegisterLook'], r) // 审批登记表
const RegisterAdd  = r => require(['@/views/Register/RegisterAdd'], r) // 审批登记表
const RegisterView = r => require(['@/views/Register/RegisterView'], r) // 审批登记表
const Registerdetial = r => require(['@/views/Register/Registerdetial'], r) // 审批登记表



const businessDetails = r => require(['@/views/businessDetails/index'], r) // 业务详情信息
const businessDetailsMobile = r => require(['@/views/businessDetailsMobile/index'], r) // 业务详情信息
const searchSup = r => require(['@/components/mobile/searchSup'], r)

const roleStatistics = r => require(['@/views/roleStatistics'], r) // 角色补人明细
const error401 = r => require(['@/views/error401'], r) // 角色补人明细
const midPage = r => require(['@/views/midPage'], r)// 中间页


// const seeTodo = "5acdbdb807fe764c0184b1b93ec96f34"

// 交圈记录
const circleRecord = r => require(['@/views/circleRecord/circleRecord'], r)


Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/error401',
      component:error401,
    },
    {
      path: "/midPage",
      component: midPage,
      name: 'midPage'
    },
     //日志
    {
      path:'/logPageView',
      component:logPageView,
      children:[
        {
          path:'/logPageView/logPageAdd',
          component:logPageAdd,
          meta: {
            keepAlive: true
          },
        },
        {
          path:'/logPageView/logPageLook',
          component:logPageLook,
          meta: {
            keepAlive: true
          },
        },
    ]
    },
    //审批登记表
    {
      path:'/RegisterView',
      component:RegisterView,
      children:[
        {
          path:'/RegisterView/RegisterAdd',
          component:RegisterAdd,
          meta: {
            keepAlive: true
          },
        },
        {
          path:'/RegisterView/RegisterLook',
          component:RegisterLook,
          meta: {
            keepAlive: true
          },
        },
    ]
    },
    {
      path:'/Registerdetial',
      component:Registerdetial
    },
    {
      path:'/roleStatistics',
      component:roleStatistics
    },
    {
      path:'/logPagedetial',
      component:logPagedetial
    },
    {
      path:'/ownerConfigTabel',
      component:ownerConfigTabel
    },
    {
      path: '/beifen',
      component: beifen
    },
    {
      path: '/secondClick',
      component: secondClick
    },
    {
      path: '/formread',
      component: formread
    },
    {
      path: '/formiframe',
      component: formiframe
    },
    {
      path: '/primaryBtnSuccess',
      component: primaryBtnSuccess
    },
    {
      path: '/form',
      component: form
    },
    {
      path: '/demotest6',
      component: demotest
    },
    {
      path: '/noLoading',
      component: noLoading
    },
    { // 审批流程
      path: '/',

      component: approvalView,
      redirect: '/process',
      meta: {
        keepAlive: true
      },
      children: [
        {
          path: '/',
          redirect: '/personCenter'
        },
        {
          path: '/iframeForm',
          redirect: '/process',
          meta: {
            keepAlive: true
          }
        },
        {
          path: '/processInfo',
          redirect: '/process',
          component: processInfo,
          meta: {
            keepAlive: true
          }
        }, {
          path: '/processHistroy',
          redirect: '/process',
          component: processHistroy,
          meta: {
            keepAlive: true
          }
        },
      ]

    },
    { // 已办
      path: '/hasHandle',
      redirect: '/process',
      component: hasHandle,
      children: [{
        path: '/hasHandle',
        redirect: '/process'
      },
      {
        path: '/hasHandle/iframeForm',
        redirect: '/process'
      }, {
        path: '/hasHandle/processInfo',
        redirect: '/process'
      }, {
        path: '/hasHandle/processHistroy',
        redirect: '/process'
      }
      ]
    },
    { // 发起流程
      path: '/process',

      component: processView,
      children: [{
        path: '/process',
        redirect: '/process/iframeForm'
      },
      {
        path: '/process/iframeForm',
        // component: processIframeForm
        name: 'iframeForm'
      },
      {
        path: '/process/readingLog',
        name: 'readingLog'
      },
      {
        path: '/process/processInfo',
        name: 'processInfo',
        component: processInfo2
      }, 
      {
        path: '/process/circleRecord',//交圈记录
        name:"circleRecord",
        component: circleRecord
      },
      {
        path: '/process/onlyReadProcessInfo',
        name: 'onlyReadProcessInfo',
        component: onlyReadProcessInfo
      },
      {
        path: '/check',
        component: check,
        name: 'check',
        meta: {
          keepAlive: true
        }

      }, 
      {
        path: '/examine',
        component: examine
      },
      {
        path: '/search',
        component: search
      },
      {
        path: '/selectrole',
        name: 'selectrole',
        component: selectrole
      },
      {
        path: '/selectPerson',
        name: 'selectPerson',
        component: selectPerson
      },
      ]
    },
    {
      path: '/forward',
      component: forward,
      name: 'forward',
      // meta: {
      //   keepAlive: true
      // }
    },
    {
      path: '/searchForward',
      component: searchForward,
      name: 'searchForward',
    },
    // 角色补全
    {
      path: '/roleCompletionReport',
      name: 'roleCompletionReport',
      component: roleCompletionReport
    },
    {
      path: '/roleCompletion',
      name: 'roleCompletion',
      component: roleCompletion
    },
    {
      path: '/roleCompletionMobile',
      name: 'roleCompletionMobile',
      component: roleCompletionMobile
    },
    { // 个人中心
      path: '/personCenter',
      component: personCenter,
      children: [{
        path: '/personCenter',
        redirect: '/myTodoBelongToMe'
      },
      {
        path: '/myTodoBelongToMe',
        component: myTodoBelongToMe
        // meta:{
        //   title:'流程平台'
        // }
      }, {
        path: '/myAlreadydone',
        component: myAlreadydone
        // meta:{
        //   title:'流程平台'
        // }
      }, {
        path: '/myInitiation',
        component: myInitiation
        // meta:{
        //   title:'流程平台'
        // }
      }, {
        path: '/myProcessMap',
        component: myProcessMap
      }, {
        path: '/myBpmPortal',
        component: myBpmPortal
      }, {
        path: '/myInterApprover',
        component: myInterApprover
      },

      ]
    },
    {
      path: '/myMaintain', // bpm Workspace 嵌套的页面
      component: myMaintain
    },
    {
      path: '/test',
      component: Test
    }, 
    {
      path: '/processTest',
      component: processTest
    }, 
    {
      path: '/countersign',
      component: countersign
    },
    {
      path: '/templateExport',
      component: templateExport
    },
    {
      path: '/toDoException',
      component: toDoException
    },
    {
      path: '/toPushMq',
      component: toPushMq
    },
    {
      path: '/changePeople',
      component: changePeople
    },
    {
      path: '/timeoutReminder',
      component: timeoutReminder
    },
    {
      path: '/businessDetails',//角色补人业务信息
      component: businessDetails
    },
    {
      path: '/businessDetailsMobile',//角色补人业务信息移动端
      component: businessDetailsMobile
    },
    {
      path: '/searchSup',//角色补人业务信息移动端
      component: searchSup
    },    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js